export const pickLatestByDate = <T extends { date: string }>(items: T[]): T =>
  items.reduce((latest, current) =>
    new Date(current.date) > new Date(latest.date) ? current : latest
  );
